import { wsService } from "./wsService";
import { payslipService } from "./payslipService";

import sections from "@/constants/sections";

const section = sections.SECTION_MY_PAYSLIPS;

// param: { period_year, type } -> result: { list, pending }
function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function pending_count() {
  return wsService.make_get_request(section + "/pending-count");
}

// El firmado si ya se firmo, si no el original. La primera apertura registra la lectura (necesaria para firmar)
function file(id) {
  return wsService.make_get_request(section + "/file/" + id, { responseType: "arraybuffer" }).then(payslipService.pdfResponse);
}

// Firma dibujada -> result: { signature: data URL o null }
function signature(id) {
  return wsService.make_get_request(section + "/signature/" + id);
}

// param: { id, password, conformity, reason, signature }
function sign(param = {}) {
  return wsService.make_post_request(section + "/sign", param);
}

export const myPayslipService = {
  section,
  filter,
  pending_count,
  file,
  sign,
  signature,
};
